import { MaskedPatternOptions } from 'imask';
import { IMask } from 'react-imask';

/**
 * TimeMask HH:MM format
 */
export const timeMask = (): MaskedPatternOptions => {
  return {
    mask: 'HH:MM',
    lazy: true,

    blocks: {
      HH: {
        mask: IMask.MaskedRange,
        from: 0,
        to: 23,
        maxLength: 2,
        placeholderChar: 'H',
        autofix: true,
      },
      MM: {
        mask: IMask.MaskedRange,
        from: 0,
        to: 59,
        maxLength: 2,
        placeholderChar: 'M',
        autofix: true,
      },
    },
  };
};
